import React from 'react';
import SwitchInput from '../../../../../muiComponents/switchInput/SwitchInput';
import TextInput from '../../../../../muiComponents/TextInput/TextInput';
import DateInput from '../../../../../muiComponents/DateInput';
import { AttributeDefinitionFieldType } from '../../../types/zitoneoServicesTypes';

interface ScraperAttributeValueInputProps {
    fieldType: AttributeDefinitionFieldType;
    label: string;
    value: string;
    onChange: (value: string) => void;
    onFocus?: () => void;
    className?: string;
    disabled?: boolean;
}

/**
 * Renders the input that matches a scraped attribute type (switch, number,
 * date or text). Values are always handled as database strings.
 */
const ScraperAttributeValueInput = ({
    fieldType,
    label,
    value,
    onChange,
    onFocus,
    className = '',
    disabled = false,
}: ScraperAttributeValueInputProps) => {
    let input: React.ReactNode;
    switch (fieldType) {
        case AttributeDefinitionFieldType.BOOLEAN:
            input = (
                <div className='switch-input__container'>
                    <SwitchInput
                        labelText={label}
                        checked={value === 'True'}
                        onChangeMethod={(
                            _event: React.ChangeEvent<HTMLInputElement>,
                            checked: boolean
                        ) => onChange(checked ? 'True' : 'False')}
                        labelPlacement='start'
                        disabled={disabled}
                    />
                </div>
            );
            break;
        case AttributeDefinitionFieldType.NUMBER:
            input = (
                <TextInput
                    labelText={label}
                    type='number'
                    value={value}
                    deleteIcon={false}
                    disabled={disabled}
                    handleChange={(
                        _event: React.ChangeEvent<HTMLInputElement>,
                        newValue: string
                    ) => onChange(newValue)}
                />
            );
            break;
        case AttributeDefinitionFieldType.DATE:
            input = (
                <DateInput
                    labelText={label}
                    value={value}
                    disabled={disabled}
                    onChange={(newDate: Date | null) =>
                        onChange(newDate ? newDate.toISOString() : '')
                    }
                />
            );
            break;
        case AttributeDefinitionFieldType.STRING:
        default:
            input = (
                <TextInput
                    labelText={label}
                    value={value}
                    deleteIcon={false}
                    disabled={disabled}
                    handleChange={(
                        _event: React.ChangeEvent<HTMLInputElement>,
                        newValue: string
                    ) => onChange(newValue)}
                />
            );
            break;
    }
    return (
        <div
            className={`service-scraper__attribute-value ${className}`}
            onFocus={onFocus}
        >
            {input}
        </div>
    );
};

export default ScraperAttributeValueInput;
